/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import ReactDOM from "react-dom";
import { HashRouter, Route, Switch } from "react-router-dom";
import { Provider } from "mobx-react";
import { configure } from "mobx";
import PrivateRoute from "./components/Security/PrivateRoute";
import * as stores from "./stores";

import Login from "./views/autenticacao/Login";
import RecuperarSenha from "./views/autenticacao/RecuperarSenha";
import SemAcesso from "./views/autenticacao/SemAcesso";
import App from "./App";

import "react-toastify/dist/ReactToastify.css";
import "./styles/scss/style.css";

configure({ strict: "always" });

ReactDOM.render(
  <React.Fragment>
    <Provider {...stores}>
      <HashRouter>
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route exact path="/recuperar" component={RecuperarSenha} />
          <Route exact path="/semacesso" component={SemAcesso} />

          <PrivateRoute path="/" component={App} />
        </Switch>
      </HashRouter>
    </Provider>
  </React.Fragment>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js